<template>
  <inertia-link :href="route('customer.show.angebote', {'customer': company.id})">
    {{ company.name }}
  </inertia-link>
</template>

<script>
export default {
   props: {
      company: {
         type: Object,
         required: true,
      }
   }
}
</script>

  <style>
  </style>
